type Props = {
  icon?: React.ReactNode;
};

const ListItemIcon = ({ icon }: Props) => {
  return (
    icon && (
      <span className="relative mr-8 flex h-[20px] min-h-[20px] w-[20px] min-w-[20px] items-center justify-center">
        {icon}
      </span>
    )
  );
};
export default ListItemIcon;
